var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.$root.isLoaded
        ? _c("b-navbar", {
            attrs: { "fixed-top": true },
            scopedSlots: _vm._u(
              [
                {
                  key: "brand",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "logo" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "dashboard" } } },
                            [
                              _c("img", {
                                staticClass: "full",
                                attrs: { src: require("@/assets/logo.png") },
                              }),
                              _c("img", {
                                staticClass: "favicon",
                                attrs: { src: require("@/assets/favicon.png") },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "end",
                  fn: function () {
                    return [
                      _vm.isMobile
                        ? _c("navigation", {
                            attrs: {
                              isMobile: _vm.isMobile,
                              activeItem: _vm.activeItem,
                              activeGroup: _vm.activeGroup,
                            },
                            on: {
                              toggleGroup: _vm.toggleGroup,
                              doLogout: _vm.doLogout,
                            },
                          })
                        : _c("b-navbar-item", { attrs: { tag: "div" } }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.doLogout.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("users.logout")))]
                            ),
                          ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3426253725
            ),
          })
        : _vm._e(),
      _vm.$root.isLoaded
        ? _c("div", { staticClass: "wrapper" }, [
            _c(
              "section",
              { staticClass: "sidebar" },
              [
                _c(
                  "b-sidebar",
                  {
                    attrs: {
                      position: "static",
                      mobile: "hide",
                      fullheight: true,
                      open: true,
                      "can-cancel": false,
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "b-menu",
                          { attrs: { accordion: false } },
                          [
                            !_vm.isMobile
                              ? _c("navigation", {
                                  attrs: {
                                    isMobile: _vm.isMobile,
                                    activeItem: _vm.activeItem,
                                    activeGroup: _vm.activeGroup,
                                  },
                                  on: { toggleGroup: _vm.toggleGroup },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "main" },
              [
                _vm.serverConfig.needs_restart || _vm.serverConfig.update
                  ? _c("div", { staticClass: "global-notices" }, [
                      _vm.serverConfig.needs_restart
                        ? _c(
                            "div",
                            { staticClass: "notification is-danger" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("settings.needsRestart")) +
                                  " — "
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "is-primary",
                                  attrs: { size: "is-small" },
                                  on: {
                                    click: function ($event) {
                                      _vm.$utils.confirm(
                                        _vm.$t("settings.confirmRestart"),
                                        _vm.reloadApp
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("settings.restart")) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.serverConfig.update
                        ? _c(
                            "div",
                            { staticClass: "notification is-success" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("settings.updateAvailable", {
                                      version: _vm.serverConfig.update.version,
                                    })
                                  ) +
                                  " "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.serverConfig.update.url,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("View")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("router-view", { key: _vm.$route.fullPath }),
              ],
              1
            ),
          ])
        : _vm._e(),
      !_vm.$root.isLoaded
        ? _c("b-loading", { attrs: { active: "" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }